:host {
  --z-table--cells-padding: calc(var(--space-unit) * 2);

  position: relative;
  display: block;
  overflow: auto;
  max-width: 100%;
  box-sizing: border-box;
  background-color: var(--color-surface01);
}

:host([expandable]) {
  --z-table--expand-button-size: 40px;
}

:host([bordered]) {
  --z-table--cell-left-border: 1px solid var(--color-surface03);
}
